export enum OfferStatus {
  ACCEPTED = 'ACCEPTED',
  OPEN = 'OPEN',
  REJECTED = 'REJECTED',
  FINAL = 'FINAL',
  RETRACTED = 'RETRACTED',
  REJECTION = 'REJECTION',
  NOLONGERACTIVE = 'NOLONGERACTIVE',
  PENDING = 'PENDING',
  REVISION = 'REVISION'
}
